import React, { useEffect, useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import illustration from "images/server-illustration-2.svg";
import logo from "images/cargosailor_logo.png";
// import googleIconImageSrc from "images/google-icon.png";
// import twitterIconImageSrc from "images/twitter-icon.png";
import { ReactComponent as SignUpIcon } from "feather-icons/dist/icons/user-plus.svg";
import { ReactComponent as AlertIcon } from "feather-icons/dist/icons/alert-triangle.svg";
import { useHistory, useLocation } from "react-router-dom";
import { requestServer } from '../services/request'
import { RadioGroup, RadioButton } from 'react-radio-buttons';

const Container = tw(ContainerBase)`min-h-screen bg-orange-900 text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-9/12 p-6 sm:p-12`;
const LogoLink = tw.a`cursor-pointer`;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;

// const SocialButtonsContainer = tw.div`flex flex-col items-center`;
// const SocialButton = styled.a`
//   ${tw`w-full max-w-xs font-semibold rounded-lg py-3 border text-gray-900 bg-gray-100 hocus:bg-gray-200 hocus:border-gray-400 flex items-center justify-center transition-all duration-300 focus:outline-none focus:shadow-outline text-sm mt-5 first:mt-0`}
//   .iconContainer {
//     ${tw`bg-white p-2 rounded-full`}
//   }
//   .icon {
//     ${tw`w-4`}
//   }
//   .text {
//     ${tw`ml-4`}
//   }
// `;

// const DividerTextContainer = tw.div`my-12 border-b text-center relative`;
// const Para = tw.p`mt-20 mb-2 text-center first:mt-0`;
// const DividerText = tw.div`leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform -translate-y-1/2 absolute inset-x-0 top-1/2 bg-transparent`;

// const Grid = tw.div`grid grid-cols-1 sm:grid-cols-2 gap-3`;
// const Warn = tw.p`text-red-500 justify-end flex p-2 bg-red-100 mt--1 rounded-b-md`;
const Spinner = tw.span`animate-pulse w-5 h-5 border-white rounded-full bg-white`;
// const Form = tw.form`mx-auto`;
const Input = tw.input`w-full px-4 py-4 border border-gray-50 placeholder-gray-500 text-sm focus:outline-none focus:border-orange-500 mt-5`;
const Textarea = tw.textarea`w-full px-4 py-4 border border-gray-50 placeholder-gray-500 text-sm focus:outline-none focus:border-orange-500 mt-5`;
const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-orange-500 text-gray-100 w-full py-4 rounded hover:bg-orange-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;
const ProcessButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-orange-300 text-gray-100 w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
  disabled
`;
// const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-purple-100 text-center hidden lg:flex justify-center`;
// const IllustrationImage = styled.div`
//   ${props => `background-image: url("${props.imageSrc}");`}
//   ${tw`m-12 xl:m-16 w-full max-w-lg bg-contain bg-center bg-no-repeat`}
// `;

export default ({
  logoLinkUrl = "/",
  illustrationImageSrc = illustration,
  headingText = "Fill Up All The Details",
  submitButtonText = "Submit",
  SubmitButtonIcon = SignUpIcon,
  WarnIcon = AlertIcon,
  tosUrl = "#",
  privacyPolicyUrl = "#",
  signInUrl = "#"
}) => {

  let history = useHistory();
  let location = useLocation();

  const [err, setErr] = useState(false)
  const [process, setProcess] = useState(true)
  const [payload, setPayload] = useState({
    "env": "demo",
    "customername": "",
    "contact": "",
    "email": "",
    "address": "",
    "isWalking": null,
    "amount": 10000,
    "status": "In progress",
    "service" : "domestic",
    "serviceprovider": "",
    "sector": "",
    "weight": "",
    "mode": "",
    "volumetricParam": {}
  })

  const getDetails = (e) => {
    e.preventDefault();
    console.log(payload);
    if (payload.isWalking!==null) {
      setProcess(false)
      const load = {
        "api_name": "initiateDomesticPayment",
        "data": payload
      }
      requestServer(load).then((res) => {
        setProcess(true)
        console.log(res.data);
        if (!payload.isWalking) {
          if (res.data.data) {
            // history.push('/checkout/' + res.data.data.id)
            history.push({
              pathname: '/checkout/' + res.data.data.razorpayOrderId,
              state: {
                "email": payload.email,
                "contact": payload.contact
              }
            })
            // storeData('userData', res.data.data)
          }
        }
        else {
          history.push('/thankyou')
        }
      }).catch((err) => {
        setProcess(true)
        console.log(err)
      })
    } else {
      setErr(true)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    if (location.state) {
      console.log(location.state[0].data, location.state[1]);
      setPayload(prev =>
        ({
          ...prev,
          serviceprovider: location.state[1]?.service,
          sector: location.state[0]?.data?.sector,
          weight: location.state[0]?.data?.weight,
          mode: location.state[0]?.data?.mode,
          volumetricParam: location.state[0]?.data?.volumetricParam || {}
        }))
    }
    else
      history.push('/')
  }, [location, history])

  return (
    <AnimationRevealPage disabled>
      <Container>
        <Content>
          {/* <MainContainer>
          
        </MainContainer> */}
          <MainContainer>
            <LogoLink onClick={() => history.push(logoLinkUrl)}>
              <LogoImage src={logo} />
            </LogoLink>
            <MainContent>
              <Heading>{headingText}</Heading>
              <form onSubmit={getDetails}>
              <FormContainer>
                <Input required type="text" placeholder="Enter your name" value={payload.customername} onChange={(ch) => { let chx = ch.target.value; setPayload(prev => ({ ...prev, customername: chx })) }} />
                <Input required type="email" placeholder="Enter your email" value={payload.email} onChange={(ch) => { let chx = ch.target.value; setPayload(prev => ({ ...prev, email: chx })) }} />
                <Input required type="tel" placeholder="Enter your phone no." tw="mb-5" value={payload.contact} onChange={(ch) => { let chx = ch.target.value; setPayload(prev => ({ ...prev, contact: chx })) }} />
                
                {err && <p tw="text-red-500 mb-2">Please select any one</p>}
                <RadioGroup onChange={(ch) => setPayload(prev => ({ ...prev, isWalking: ch !== "TRUE" ? false : true }))} horizontal>
                  <RadioButton value="FALSE" iconSize={20} padding={15} rootColor={"#d2d2d2"} pointColor={"#ED8936"}>
                    <p className="selext">Doorstep</p>
                  </RadioButton>
                  <RadioButton value="TRUE" iconSize={20} padding={15} rootColor={"#d2d2d2"} pointColor={"#ED8936"}>
                    <p className="selext">Walk-in</p>
                  </RadioButton>
                </RadioGroup>
                <Textarea required rows="4" type="text" placeholder="Enter your full address" value={payload.address} onChange={(ch) => { let chx = ch.target.value; setPayload(prev => ({ ...prev, address: chx })) }} />
                {!process ? <ProcessButton disabled>
                  <Spinner />
                  <span className="text" tw="animate-pulse">Processing</span>
                </ProcessButton> :
                  <SubmitButton type="submit">
                    <SubmitButtonIcon className="icon" />
                    <span className="text">{submitButtonText}</span>
                  </SubmitButton>
                }

                <p tw="mt-6 text-xs text-gray-600 text-center">
                  I agree to abide by Cargo Sailor's{" "}
                  <a href={tosUrl} tw="border-b border-gray-500 border-dotted">
                    Terms of Service
                  </a>{" "}
                  and its{" "}
                  <a href={privacyPolicyUrl} tw="border-b border-gray-500 border-dotted">
                    Privacy Policy
                  </a>
                </p>

                {/* <p tw="mt-8 text-sm text-gray-600 text-center">
                  Already have an account?{" "}
                  <a href={signInUrl} tw="border-b border-gray-500 border-dotted">
                    Sign In
                  </a>
                </p> */}
              </FormContainer>
              </form>
            </MainContent>
          </MainContainer>
          {/* <IllustrationContainer>
          <IllustrationImage imageSrc={illustrationImageSrc} />
        </IllustrationContainer> */}
        </Content>
      </Container>
    </AnimationRevealPage>
  )
};